import { Icon, ProgressBar } from "@blueprintjs/core"
import React from "react"
import { useSelector } from "react-redux"
import ReactTable from "react-table"
import CustomSpinner from "components/Atoms/CustomSpinner"
import CustomTooltip from "components/Atoms/CustomTooltip"
import StyledLink from "components/Atoms/StyledLink"
import { TripStatusMap } from "graphql/types/custom.types"
import { PAGE_SIZE } from "store/vehicle.redux"
import { readableDate } from "utils/custom.utils"
import { useAssignedTripsList } from "../assigned/useAssignedTrips"

export function Cell({ onClick = undefined, title, subtitle = undefined }) {
  return (
    <section className="vt-table-cell" onClick={onClick}>
      <span className="vt-title">{title}</span>
      <br></br>
      <span className="vt-subtitle">{subtitle}</span>
    </section>
  )
}

export default function AssignedTable() {
  const { trips, loading, error } = useAssignedTripsList()
  const page = useSelector(state => state.vehicle.page)

  const COLUMNS = [
    {
      width: 60,
      Header: "#",
      Cell({ index }) {
        return page * PAGE_SIZE + (index + 1)
      },
      Footer({ data }) {
        return <span>#{data?.length ?? 0}</span>
      },
    },
    {
      width: 170,
      Header: "Date",
      accessor: "date",
      Cell({ value }) {
        return <Cell title={readableDate(value)} />
      },
    },
    {
      accessor: "vehicle",
      Header: "Vehicle",
      Cell({ value, original }) {
        return (
          <Cell
            title={
              <StyledLink
                to={`/d/vehicle/trip/${original?.uuid}/${original?.id}`}
              >
                {value?.registrationNumber}
              </StyledLink>
            }
            subtitle={value?.vehicleType?.name}
          />
        )
      },
    },
    {
      accessor: "vehicle.driver",
      Header: "Driver",
      Cell({ value }) {
        return <Cell title={value?.fullName} subtitle={value?.number} />
      },
    },
    {
      accessor: "aggregator",
      Header: "Aggregator",
      Cell({ value }) {
        return <Cell title={value?.fullName} subtitle={value?.number} />
      },
    },
    {
      accessor: "status",
      Header: "Status",
      Cell({ value }) {
        return (
          <Cell
            title={
              <>
                <Icon
                  icon="dot"
                  iconSize={25}
                  intent={
                    value === "CP"
                      ? "success"
                      : value === "DS"
                      ? "danger"
                      : value === "OT"
                      ? "warning"
                      : "none"
                  }
                ></Icon>

                {TripStatusMap?.[value]}
              </>
            }
          />
        )
      },
    },
    {
      accessor: "id",
      Header: "SKU Status",
      Cell({ original }) {
        let totalBooked = 0
        let totalRequired = 0
        for (let i = 0; i < original?.bookings?.length; i++) {
          //
          const b = original?.bookings?.[i]
          if (b?.procuredQuantity || b?.procuredQuantity === 0)
            totalBooked += b.procuredQuantity
          if (b?.requiredQuantity || b?.requiredQuantity === 0)
            totalRequired += b.requiredQuantity
        }
        const percentage =
          totalBooked >= 0 || totalRequired >= 0
            ? totalBooked / totalRequired
            : 0

        return (
          <section className="vt-crates-progress w-3/4 h-full">
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-1">
                <CustomTooltip content="Pickup Quantity">
                  <Icon icon="export" className="mr-2" />
                </CustomTooltip>{" "}
              </div>
              <div className="col-span-11">
                <ProgressBar
                  animate={false}
                  value={percentage}
                  intent={
                    percentage > 0.75
                      ? "success"
                      : percentage > 0.5
                      ? "warning"
                      : "danger"
                  }
                />
                <span className="vt-subtitle mt-1">
                  {totalBooked} / {totalRequired}
                </span>
              </div>
            </div>
          </section>
        )
      },
    },
  ]

  if (loading) return <CustomSpinner />
  if (error) return `${error.message}`
  return (
    <div
      className="vt-vehicle-list-table"
      // className={classList("vt-vehicle-list-table", {
      //   "vt-vehicle-list-table-expanded": !filterOpen,
      //   "vt-vehicle-list-table-shrink": filterOpen
      // })}
    >
      <ReactTable
        data={trips}
        loadingText="Fetching Schedules..."
        className="-highlight vt-schedule-table-new vt-vehicle-list-react-table"
        resizable={true}
        pageSize={PAGE_SIZE}
        showPagination={false}
        columns={COLUMNS}
      />
    </div>
  )
}
